import React from "react";
import PropTypes from "prop-types";
import Icon from 'SF/MaterialIcon';
import css from './SurveySearchIcon.css';

export default class SurveySearchIcon extends React.PureComponent {
    render() {
        return (
            <div
                className={css['survey-search']}
                aria-label="Search for students in survey"
                onClick={this.props.onSearchIconClickHandler}
                tabIndex="0"
                role="button">
                <Icon icon="search" className={css['search-icon']}/>
                <span>Search</span>
            </div>
        );
    }
}

SurveySearchIcon.propTypes = {
    onSearchIconClickHandler: PropTypes.func.isRequired
};
